function Footer(){
  return (
    <div className="footer">
      <p className="textright">Last updated 6/9/2026</p>
    </div>)
}

export default Footer
;
